import { useContext } from "react";
import { AssessmentQuestionContext } from "./AssessmentDetail";

const useAssessmentOperations = () => useContext(AssessmentQuestionContext);

export default useAssessmentOperations;
